import type { SignedPortalHandoffClaim } from "~portal/helpers/portalHandoffState";

import classifyHost, { normalizeHost } from "~portal/helpers/hostClassification";

const PORTAL_PATH_PATTERN = /^\/portal\/([^/]+)/;

export type PortalLoginHint = { slug: string } | { host: string };

const resolvePortalLoginHint = (
	host: string,
	pathname: string,
	portalHandoff?: SignedPortalHandoffClaim
): Maybe<PortalLoginHint> => {
	if (portalHandoff) return { host: portalHandoff.domain };

	const classification = classifyHost(host);
	if (classification.kind === "vanityTenant") return { host: normalizeHost(host) };

	const slug = classification.kind === "app" ? PORTAL_PATH_PATTERN.exec(pathname)?.[1] : undefined;
	return slug ? { slug } : null;
};

export default resolvePortalLoginHint;
